<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'WkSearchSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue',): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const module = ref<string>('wk-search');
const defaults = ref<any>({
    page: null
});

const form = computed<FormType<any>>(() =>
{
    return props.modelValue;
});

watch(() => form.value.settings, () =>
{
    triggerModel();
},
{ deep: true });

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function validate(): Promise<void>
{
    form.value.validate(schema => ({
        settings: schema.object({
            page: schema.string().nullable().required($t('[[[Wybranie strony jest wymagane]]]'))
        })
    }));
}
onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});

defineExpose({
    validate
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Strona z modułu wyszukiwarki]]]')" :invalid-feedback="form.$errors.first('settings.page')" :state="form.$errors.state('settings.page')" required>
        <EditoPageSelector v-model="form.settings.page" :module="module" label="" :preview="false" class="mb-0" />
    </IdeoFormGroup>
</template>
